module.exports = __webpack_public_path__ + "img/surf.265abb34.jpg";